import { ChangeDetectionStrategy, Component, ViewChild } from '@angular/core';
import { AlertController, IonButton, IonButtons, IonHeader, IonIcon, IonTitle, IonToolbar, ModalController } from '@ionic/angular/standalone';
import { LetDirective } from '@ngrx/component';
import { select, Store } from '@ngrx/store';
import { Observable, take, tap } from 'rxjs';
import { HeadingComponent } from 'src/app/components/heading/heading.component';
import { SpinnerComponent } from 'src/app/components/spinner/spinner.component';
import { CombinedClinicalNoteAttachment, selectedClinicalNote, selectedCombinedClinicalNoteAttachments, selectedDocumentInstance } from 'src/app/store/patient-clinical-note/patient-clinical-note.selectors';
import { AppState } from 'src/app/store/reducers';
import { ClinicalNote, DocumentInstance } from 'src/app/types/aggregate-graph.types';
import { filterUndefinedOrNull } from 'src/app/types/rxjs-custom-operator.types';
import { ClinicalNoteDocumentComponent } from '../../components/clinical-note-document/clinical-note-document.component';

@Component({
	templateUrl: './edit-clinical-note.modal.html',
	styleUrl: './edit-clinical-note.modal.scss',
	imports: [LetDirective, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, SpinnerComponent, HeadingComponent, ClinicalNoteDocumentComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditClinicalNoteModal {

	clinicalNote$: Observable<ClinicalNote>;
	documentInstance$: Observable<DocumentInstance>;
	combinedClinicalNoteAttachments$: Observable<CombinedClinicalNoteAttachment[]>;

	@ViewChild(ClinicalNoteDocumentComponent) clinicalNoteDocumentComponent!: ClinicalNoteDocumentComponent;

	private uploadsActive: boolean = false;

	constructor(private alertController: AlertController, private store: Store<AppState>, private modalController: ModalController) {
		this.clinicalNote$ = this.store.pipe(select(selectedClinicalNote), filterUndefinedOrNull(), take(1));
		this.documentInstance$ = this.store.pipe(select(selectedDocumentInstance), filterUndefinedOrNull(), take(1));
		this.combinedClinicalNoteAttachments$ = this.store.pipe(select(selectedCombinedClinicalNoteAttachments), tap(combinedAttachments => { this.uploadsActive = combinedAttachments.some(ca => !ca.attachment); }));
	}

	async close() {
		if (this.uploadsActive) {
			const alert = await this.alertController.create({
				message: 'Attachments must finish uploading',
				backdropDismiss: false,
				buttons: ['Ok']
			});
			alert.present();
		}
		else {
			this.modalController.dismiss();
		}
	}
}
